module.exports = __webpack_public_path__ + "img/brumbyhall-h-474x356.36ebcf76.jpg";